module.exports = __webpack_public_path__ + "img/9791188605026.7ce36986.jpg";